import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, delay } from 'rxjs/operators';
import { FormAutoCompleteComponent, IFormAutoCompleteViewModel } from 'src/app/share/forms/form-auto-complete/form-auto-complete.component';
import { FormInputComponent, IFormInputViewModel } from 'src/app/share/forms/form-input/form-input.component';
import { FormOkCancelComponent } from 'src/app/share/forms/form-ok-cancel/form-ok-cancel.component';
import { BasePageComponent, IBasePageOnInitArg } from 'src/app/share/pages/base-page.component';
import { IPageContentFormViewModel, IPageContentViewModel, IPageDataViewModel, IPageViewModel } from 'src/app/share/pages/pages';
import { CommonService } from 'src/app/share/services/common.service';
import { ShellService } from 'src/app/shell/shell.service';

@Component({
  selector: 'app-credit-card-identity-page',
  templateUrl: './credit-card-identity-page.component.html',
  styleUrls: ['./credit-card-identity-page.component.scss']
})
export class CreditCardIdentityPageComponent extends BasePageComponent implements OnInit {

  private readonly reservationsApiPath: string = '/api/reservations';

  /**
   * 
   * @param apiService 
   * @param shellService
   * @param activatedRate
   */
  constructor(private apiService: CommonService, protected shellService: ShellService, protected activatedRate: ActivatedRoute) {
    super(shellService, activatedRate);
  }

  /**
   * 
   * @param action 
   * @param paramData 
   * @returns 
   */
  private reservationsCommandInvoke(action: string, paramData): Observable<IPageDataViewModel> {
    return this.apiService.getData('PageCommand', 'credit-card-identity', action, paramData, this.reservationsApiPath, true);
  }

  /**
   * 
   */
  ngOnInit(): void {
    super.onInit((arg: IBasePageOnInitArg) => {
      
      // customer one time CC ID entry
      if (arg.oneTimeInfo) {
        return of({}).pipe(
          delay(2000),

          map(() => {
            const contentVm: IContentViewModel = {
              data: undefined,

              customerCcIdEntryVm: {
                token: arg.oneTimeInfo.token
              }
            };

            const ret: IPageViewModel = {
              contentVm: contentVm
            };
            return ret;
          })
        );
      }

      // user
      return of({}).pipe(
        delay(2000),

        // load content VM
        switchMap(() => {
          return of({
            cvm: this.contentViewModel(arg)
          });
        }),

        // return page VM
        map(ctx => {
          return {
            contentVm: ctx.cvm
          };
        })
      );
    }, { canRefresh: true, canAddNew: true, canGoBack: true });
  }

  /**
   * 
   * @returns 
   */
  private contentViewModel(arg: IBasePageOnInitArg): IContentViewModel {
    const vm: IContentViewModel = {
      data: {},
    };
    return vm;
  }

  /**
   * just testing it out for now
   * 
   * @param vm 
   */
  onPageAddNew(pvm: IPageViewModel, vm: IContentViewModel) {
    this.requestFormStart(pvm, vm);
  }

  //#region  request form

  /**
   * 
   */
  private async requestFormStart(pvm: IPageViewModel, vm: IContentViewModel) {
    const fvm = super.formBegin(pvm, this.requestFormVm(vm));

    await super.formLoadAsync(fvm, () => {
      return of({}).pipe(
        delay(500) /* simulate work, don't use for real */
      );
    });
  }

  /**
   * 
   * @param vm 
   * @returns 
   */
  private requestFormVm(vm: IContentViewModel): IRequestEntryFormViewModel {
    const data: IRequestEntryFormData = {
      customerSms: '732-616-5276',
      confirmationNumber: 'test-confirm'
    };

    const ret: IRequestEntryFormViewModel = {
      ...super.formVm('capture-request', { okCancelOptions: {} }),

      data: data,

      confirmationNumberInputVm: FormInputComponent.viewModel(data, 'confirmationNumber',
        { title: 'Confirmation', isRequired: true }),

      customerSmsInputVm: FormInputComponent.viewModel(data, 'customerSms',
        { title: 'Customer SMS', isRequired: true }),

      notesInputVm: FormInputComponent.viewModel(data, 'notes',
        { title: 'Notes', isRequired: false, type: 'textarea' })
    };

    this.requestFormValidate(vm, ret);

    return ret;
  }

  /**
   * 
   * @param vm 
   * @param fvm 
   */
  requestFormValidate(vm: IContentViewModel, fvm: IRequestEntryFormViewModel) {
    const valids = [
      !fvm.data.confirmationNumber ? false
        : fvm.data.confirmationNumber == 'test-confirm' ? true
        : fvm.data.confirmationNumber.split('*').length == 2 ? true
          : false,
      !fvm.data.customerSms ? false : true
    ];
    fvm.isValid = valids.filter(v => !v).length == 0;
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   * @param fvm 
   */
  async requestFormOk(pvm: IPageViewModel, vm: IContentViewModel, fvm: IRequestEntryFormViewModel) {

    const success = await FormOkCancelComponent.processOkAsync(fvm.okCancelVm, 'Submitting...',
      () => this.reservationsCommandInvoke('customer-capture-request', fvm.data));

    if (success)
      this.formEndRefresh(pvm);
  }

  //#endregion request form

}

/**
 * 
 */
interface IContentViewModel extends IPageContentViewModel {
  data: any;

  customerCcIdEntryVm?: { token: string };
}

/**
 * 
 */
interface IRequestEntryFormViewModel extends IPageContentFormViewModel {
  data: IRequestEntryFormData;

  confirmationNumberInputVm: IFormInputViewModel;

  customerSmsInputVm: IFormInputViewModel;

  notesInputVm: IFormInputViewModel;
}

/**
 * 
 */
interface IRequestEntryFormData {
  confirmationNumber: string;

  customerSms: string;

  notes?: string;
}
